angular.module('app.factories').factory('usersListFilterFactory', ($rootScope, $translate, $state, $log, listFilter, areasService) => {
    const usersListFilter = listFilter;

    usersListFilter
        .setAttributes({
            extendByDates: false,
            name: 'usersListFilter',
            providers: ['jobsOptions', 'areasOptions', 'groupsOptions', 'userStatusOptions'],
        })
        .setFields({
            filter: {
                type: 'text',
                class: 'uk-width-medium-3-5',
                label: $translate.instant('search'),
                default: '',
            },
            area_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-2-5',
                label: $translate.instant('areas'),
                optionsProvider: 'areasOptions',
                options: [],
                default: [areasService.currentId()],
            },
            group_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-1-4',
                label: $translate.instant('users.groups'),
                optionsProvider: 'groupsOptions',
                options: [],
                default: '',
            },
            job_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-1-4',
                label: $translate.instant('users.job_id'),
                optionsProvider: 'jobsOptions',
                options: [],
                default: '',
            },
            status: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-1-4',
                label: $translate.instant('users.status'),
                optionsProvider: 'userStatusOptions',
                options: [],
                default: '',
            },
            reset: {
                type: 'reset',
                class: 'uk-width-medium-1-4',
            },
        });

    return usersListFilter;
});
